import type { BookLanguage } from "@japa-reader/contracts";

export type LibraryLanguageFilter = "all" | BookLanguage;

export const BOOK_LANGUAGES: Array<{ code: BookLanguage; label: string; nativeLabel: string; locale: string }> = [
  { code: "ja", label: "Japonês", nativeLabel: "日本語", locale: "ja-JP" },
  { code: "en", label: "Inglês", nativeLabel: "English", locale: "en-US" },
  { code: "ru", label: "Russo", nativeLabel: "Русский", locale: "ru-RU" },
];

export function normalizeBookLanguage(value: unknown): BookLanguage {
  const normalized = typeof value === "string" ? value.trim().toLowerCase().replaceAll("_", "-") : "";
  if (normalized === "en" || normalized === "eng" || normalized.startsWith("en-")) return "en";
  if (normalized === "ru" || normalized === "rus" || normalized.startsWith("ru-")) return "ru";
  return "ja";
}

export function detectBookLanguage(text: string): BookLanguage {
  const sample = text.slice(0, 30_000);
  const japaneseKana = (sample.match(/[ぁ-ゖァ-ヺー]/gu) ?? []).length;
  const han = (sample.match(/\p{Script=Han}/gu) ?? []).length;
  const cyrillic = (sample.match(/\p{Script=Cyrillic}/gu) ?? []).length;
  const latin = (sample.match(/\p{Script=Latin}/gu) ?? []).length;
  const japaneseScore = japaneseKana * 3 + han;
  if (cyrillic > Math.max(12, japaneseScore, latin * 0.35)) return "ru";
  if (japaneseScore > Math.max(12, latin * 0.35)) return "ja";
  return latin > 0 ? "en" : "ja";
}

export function bookLanguageMeta(language: unknown) {
  const code = normalizeBookLanguage(language);
  return BOOK_LANGUAGES.find((item) => item.code === code) ?? BOOK_LANGUAGES[0];
}

export function validLanguageFilter(value: unknown): value is LibraryLanguageFilter {
  return value === "all" || value === "ja" || value === "en" || value === "ru";
}
